import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export const IMAGE_PLACEHOLDER = 'assets/images/lender_logo_placeholder.svg';
export const PROPERTY_IMAGE_PLACEHOLDER = 'assets/images/property-no-image.png';
export const PROFILE_IMAGE_PLACEHOLDER = 'assets/images/profile-placeholder-image.png';

@Pipe({
  name: 'safeStyle',
  standalone: true,
})
export class SafeStylePipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(url: string, placeholder?: 'property' | 'lender' | 'profile'): SafeResourceUrl {
    if (placeholder != null && url == null) {
      switch (placeholder) {
        case 'property':
          return this.sanitizer.bypassSecurityTrustStyle(`url(${PROPERTY_IMAGE_PLACEHOLDER})`);
        case 'lender':
          return this.sanitizer.bypassSecurityTrustStyle(`url(${IMAGE_PLACEHOLDER})`);
        case 'profile':
          return this.sanitizer.bypassSecurityTrustStyle(`url(${PROFILE_IMAGE_PLACEHOLDER})`);
      }
    }
    return this.sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }
}
